/* eslint-disable jsx-a11y/alt-text */
import { Form, Input } from 'antd';
import classNames from 'classnames';
import { shuffle } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import { Input } from 'reactstrap';
import AnswersType3 from './components/AnswersType3/AnswersType3';
import AnswersType6 from './components/AnswersType6/AnswersType6';
import AnswersType7 from './components/AnswersType7/AnswersType7';
import AnswerType2 from './components/AnswerType2/AnswerType2';
import AnswerType4 from './components/AnswerType4/AnswerType4';
import AnswerType5 from './components/AnswerType5/AnswerType5';
import './style.module.scss';

function Answers({ onChange = () => {}, question, value, isAnswer, onSendAnswer = () => {}, help }) {
  console.log("🚀 ~ file: Answers.jsx ~ line 15 ~ Answers ~ isAnswer", isAnswer, question.answers)
  const [answers, setAnswers] = useState('');
  useEffect(() => {
    if (
      question.question_type == 'type2' ||
      question.question_type == 'type3' ||
      question.question_type == 'type4'
    ) {
      setAnswers(shuffle(question.answers));
    }
  }, [question]);

  const onKeyPress = (event) => {
    if(event.keyCode == 13 || event.key === 'Enter'){
      if(value.length){
        onSendAnswer()
      }
    }
  }

  return (
    <div
      className={classNames('AnswersQM', {
        type3:
          question.question_type == 'type3' ||
          question.question_type == 'type4',
      })}
    >
      {question.question_type == 'type1' && (
        <Form.Item
          hasFeedback
          validateStatus={ isAnswer ? (question.answers || '').split(',').map(_i => (_i || '').toLowerCase().trim() ).includes((value || '').toLowerCase().trim()) ? 'success' : "error" : ''}
          // help="Should be combination of numbers & alphabets"
        >
          <Input onChange={(e) => onChange(e.target.value)} onKeyPress={onKeyPress} value={isAnswer ? question.answers.split(',')[0] : value} />
        </Form.Item>
        // <Input onChange={(e) => onChange(e.target.value)} value={value} />
      )}
      {question.question_type == 'type2' && (
        <AnswerType2
          onChange={onChange}
          answers={(answers && Array.isArray(answers) && answers) || []}
          value={value}
          isAnswer={isAnswer}
          help={help}
        />
      )}
      {question.question_type == 'type3' && (
        <AnswersType3
          onChange={onChange}
          answers={(answers && Array.isArray(answers) && answers) || []}
          isAnswer={isAnswer}
          help={help}
        />
      )}
      {question.question_type == 'type4' && (
        <AnswerType4
          onChange={onChange}
          answers={(answers && Array.isArray(answers) && answers) || []}
          isAnswer={isAnswer}
          help={help}
        />
      )}
      {question.question_type == 'type5' && (
        <AnswerType5 onChange={onChange} answers={question.answers} help={help} isAnswer={isAnswer}  onSendAnswer={onSendAnswer} />
      )}
      {question.question_type == 'type6' && (
        <AnswersType6 onChange={onChange} answers={question.answers} help={help} isAnswer={isAnswer} />
      )}
      {question.question_type == 'type7' && (
        <AnswersType7 onChange={onChange} answers={question.answers} help={help} isAnswer={isAnswer} />
      )}
    </div>
  );
}

export default Answers;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/Answers.jsx